import { Component, TemplateRef, Output, EventEmitter, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrackingItem, TrackingItemObject } from '@app/core';
//import { AnimateChildAst } from '@angular/animations/browser/src/dsl/animation_ast';
import { PreventiveMaintenanceService } from '@app/preventiveMaintenance/preventiveMaintenance.service';
import { FrequencyType } from '@app/core/models/frequencyType';
import { Files } from '@app/core/models/files';
import { FilesDialogComponent } from '../files-dialog/files-dialog.component';
import { CustomDateParserFormatter } from '@app/shared/dateFormatter';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'tracking-item-startdate-confirmation-dialog',
  templateUrl: './tracking-item-startdate-confirmation-dialog.component.html',
  styleUrls: ['./tracking-item-startdate-confirmation-dialog.component.css'],
  providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
     DatePipe]
})
export class TrackingItemStartConfirmationDialogComponent implements OnInit { 

  @Input() trackingItems:TrackingItem[] = [];
  @Output() closeModalEvent: EventEmitter<any> = new EventEmitter();
  @Output() confirmedDatesEvent = new EventEmitter<TrackingItem[]>();
  
  public isFailedForm: boolean = false;
  public frequencyTypeList: FrequencyType[] = [];
  public repeatedForms: any;
  

  constructor(
    public activeModal: NgbActiveModal,
    public ngbModal: NgbModal,
    private preventiveMaintenanceService: PreventiveMaintenanceService,
    public filesDialogComponent: FilesDialogComponent,
    ) { 

  }
  //getDownloadURL = this.filesDialogComponent.getDownloadURL;
  ngOnInit() {
    this.getFrequencyTypes();
  }

  
  public onHeaderChange(){

  }

  
  

  public confirmStartDates(){

    this.activeModal.dismiss();
    this.confirmedDatesEvent.emit(this.trackingItems);
    
  }

  

    public closeModal(){
    this.trackingItems = [];
    this.activeModal.dismiss();
    this.closeModalEvent.emit({});
  }

  public checkStartDate(item: TrackingItem){
    var formValue = item;
    if(formValue.startDate){
    //  formValue.startDate = new Date(formValue.startDate);
      if(!this.isValidDate(formValue.startDate)){
        formValue.startDate = Date();
      }
     
    }
  }

  private isValidDate(d: any) {
    var returnValue: boolean = false;
    if (Object.prototype.toString.call(d) === "[object Date]") {
      if (isNaN(d.getTime())) { 
        returnValue = false;
      } else {
        returnValue = true;
      }
    } else {
      returnValue = false;
    }
    return returnValue;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  //FREQUENCY TYPE METHODS//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private getFrequencyTypes(){
    this.preventiveMaintenanceService.getFrequencyTypes().subscribe(res=>{
      this.frequencyTypeList = res;
    });
  }

  

  
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}